import { en as passoverEn } from './en';
import { he as passoverHe } from './he';
import { bannerTranslations } from './banner';
import { headerTranslations } from './header';

export const translations = {
  en: {
    ...passoverEn,
    banner: bannerTranslations.en,
    header: headerTranslations.en
  },
  he: {
    ...passoverHe,
    banner: bannerTranslations.he,
    header: headerTranslations.he
  }
};

export type TranslationKey = keyof typeof translations;
export type Translation = typeof translations.he; 